"use strict";
exports.__esModule = true;
exports.getHasBottomGutter = exports.getHasAppPadding = exports.getMaxWidth = exports.WidgetWrapper = void 0;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Actsection_1 = tslib_1.__importDefault(require("./Actsection"));
var Advert_1 = tslib_1.__importDefault(require("./Advert"));
var ArticleList_1 = tslib_1.__importDefault(require("./ArticleList"));
var Banners_1 = tslib_1.__importDefault(require("./Banners"));
var CalendarEventList_1 = tslib_1.__importDefault(require("./CalendarEventList"));
var CompetitionDraw_1 = tslib_1.__importDefault(require("./CompetitionDraw"));
var CompetitionStanding_1 = tslib_1.__importDefault(require("./CompetitionStanding"));
var CtkWidget_1 = tslib_1.__importDefault(require("./CtkWidget"));
var DangerousSource_1 = tslib_1.__importDefault(require("./DangerousSource"));
var Document_1 = tslib_1.__importDefault(require("./Document"));
var EntityReference_1 = tslib_1.__importDefault(require("./EntityReference"));
var External_1 = tslib_1.__importDefault(require("./External"));
var FAQ_1 = tslib_1.__importDefault(require("./FAQ"));
var Footnotes_1 = tslib_1.__importDefault(require("./Footnotes"));
var FormattedText_1 = tslib_1.__importDefault(require("./FormattedText"));
var HiddenContent_1 = tslib_1.__importDefault(require("./HiddenContent"));
var HiddenContentEnd_1 = tslib_1.__importDefault(require("./HiddenContentEnd"));
var Iframe_1 = tslib_1.__importDefault(require("./Iframe"));
var ImageAd_1 = tslib_1.__importDefault(require("./ImageAd"));
var MatchDetail_1 = tslib_1.__importDefault(require("./MatchDetail"));
var MatchesList_1 = tslib_1.__importDefault(require("./MatchesList"));
var MatchOverview_1 = tslib_1.__importDefault(require("./MatchOverview"));
var Multiblock_1 = tslib_1.__importDefault(require("./Multiblock"));
var OnlajnyEU_1 = tslib_1.__importDefault(require("./OnlajnyEU"));
var OrganizationProfilesList_1 = tslib_1.__importDefault(require("./OrganizationProfilesList"));
var Partners_1 = tslib_1.__importDefault(require("./Partners"));
var Persons_1 = tslib_1.__importDefault(require("./Persons"));
var Photo_1 = tslib_1.__importDefault(require("./Photo"));
var PhotoGallery_1 = tslib_1.__importDefault(require("./PhotoGallery"));
var PlayerStats_1 = tslib_1.__importDefault(require("./PlayerStats"));
var PrivateContentBoundary_1 = tslib_1.__importDefault(require("./PrivateContentBoundary"));
var Products_1 = tslib_1.__importDefault(require("./Products"));
var Profile_1 = tslib_1.__importDefault(require("./Profile"));
var RaceMatchesList_1 = tslib_1.__importDefault(require("./RaceMatchesList"));
var RaceMatchOverview_1 = tslib_1.__importDefault(require("./RaceMatchOverview"));
var ResultsTable_1 = tslib_1.__importDefault(require("./ResultsTable"));
var RotatingArticle_1 = tslib_1.__importDefault(require("./RotatingArticle"));
var SectionList_1 = tslib_1.__importDefault(require("./SectionList"));
var Social_1 = tslib_1.__importDefault(require("./Social"));
var SportRecords_1 = tslib_1.__importDefault(require("./SportRecords"));
var Squad_1 = tslib_1.__importDefault(require("./Squad"));
var Table_1 = tslib_1.__importDefault(require("./Table"));
var TableOfContents_1 = tslib_1.__importDefault(require("./TableOfContents"));
var Television_1 = tslib_1.__importDefault(require("./Television"));
var TextBlock_1 = tslib_1.__importDefault(require("./TextBlock"));
var UsersList_1 = tslib_1.__importDefault(require("./UsersList"));
var Video_1 = tslib_1.__importDefault(require("./Video"));
var Voting_1 = tslib_1.__importDefault(require("./Voting"));
var EcoMail_1 = tslib_1.__importDefault(require("./EcoMail"));
var EnetpulseWidget_1 = tslib_1.__importDefault(require("./EnetpulseWidget"));
var HtmlList_1 = tslib_1.__importDefault(require("./HtmlList"));
exports.WidgetWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: ", ";\n  min-height: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  min-width: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  clear: both;\n"], ["\n  margin-bottom: ",
    ";\n  min-height: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  min-width: 0; /* react-slick blbne, ked je umiestneny do flexboxu - toto to riesi */\n  clear: both;\n"])), function (_a) {
    var theme = _a.theme, hasBottomGutter = _a.hasBottomGutter;
    return hasBottomGutter && polished_1.em(theme.grid.gutterWidth * 2.5);
});
function getMaxWidth(widget, theme) {
    if (widget.type === 'photo' && widget.fullscreen) {
        return 0;
    }
    return utilities_1.getProp(theme, ['app', 'maxWidth'], 1200);
}
exports.getMaxWidth = getMaxWidth;
function getHasAppPadding(widget) {
    if (widget.type === 'photo' && widget.fullscreen) {
        return false;
    }
    return true;
}
exports.getHasAppPadding = getHasAppPadding;
function getHasBottomGutter(widget) {
    return !['text', 'textBlock'].includes(widget.type);
}
exports.getHasBottomGutter = getHasBottomGutter;
// @TODO prerobit na mapu
var GenericWidget = function (_a) {
    var widget = _a.widget, renderLink = _a.renderLink, renderEmpty = _a.renderEmpty, override = _a.override, theme = _a.theme;
    function render() {
        switch (widget.type) {
            case 'text':
                return react_1["default"].createElement(FormattedText_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'articlelist':
                return (react_1["default"].createElement(ArticleList_1["default"], { data: widget, renderLink: renderLink, renderEmpty: renderEmpty, override: override }));
            case 'entityReference':
                return (react_1["default"].createElement(EntityReference_1["default"], { data: widget, renderLink: renderLink, renderEmpty: renderEmpty, override: override }));
            case 'actsection':
                return (react_1["default"].createElement(Actsection_1["default"], { data: widget, renderLink: renderLink, renderEmpty: renderEmpty }));
            case 'calendarEventList':
                return (react_1["default"].createElement(CalendarEventList_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'sectionlist':
                return (react_1["default"].createElement(SectionList_1["default"], { data: widget, renderLink: renderLink, renderEmpty: renderEmpty }));
            case 'dangerousSource':
                return (react_1["default"].createElement(DangerousSource_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'photo':
                return react_1["default"].createElement(Photo_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'photogallery':
                return react_1["default"].createElement(PhotoGallery_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'table':
                return react_1["default"].createElement(Table_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'iframe':
                return react_1["default"].createElement(Iframe_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'onlajny.eu':
                return react_1["default"].createElement(OnlajnyEU_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'video':
                return react_1["default"].createElement(Video_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'sportnetvideo':
            case 'livestream':
            case 'youtube':
                return (react_1["default"].createElement(Video_1["default"], { data: {
                        type: 'video',
                        url: widget.uri
                    }, renderEmpty: renderEmpty }));
            case 'resultsTable':
                return react_1["default"].createElement(ResultsTable_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'imagead':
                return react_1["default"].createElement(ImageAd_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'multiblock':
                return (react_1["default"].createElement(Multiblock_1["default"], { data: widget, renderLink: renderLink, renderEmpty: renderEmpty, override: override }));
            case 'rotatingArticle':
                return (react_1["default"].createElement(RotatingArticle_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'social':
                return react_1["default"].createElement(Social_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'voting':
                return react_1["default"].createElement(Voting_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'partners':
                return react_1["default"].createElement(Partners_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'persons':
                return react_1["default"].createElement(Persons_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'faq':
                return react_1["default"].createElement(FAQ_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'document':
                return react_1["default"].createElement(Document_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'externalArticle':
                return react_1["default"].createElement(External_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'television':
                return react_1["default"].createElement(Television_1["default"], { data: widget, renderLink: renderLink });
            case 'sportRecords':
                return react_1["default"].createElement(SportRecords_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'matchesList':
                return react_1["default"].createElement(MatchesList_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'raceMatchesList':
                return (react_1["default"].createElement(RaceMatchesList_1["default"], { renderLink: renderLink, data: widget, renderEmpty: renderEmpty }));
            case 'raceMatchOverview':
                return (react_1["default"].createElement(RaceMatchOverview_1["default"], { renderLink: renderLink, data: widget, renderEmpty: renderEmpty }));
            case 'competitionDraw':
                return (react_1["default"].createElement(CompetitionDraw_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'competitionStanding':
                return (react_1["default"].createElement(CompetitionStanding_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'matchDetail':
                return react_1["default"].createElement(MatchDetail_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'matchOverview':
                return react_1["default"].createElement(MatchOverview_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'playerStats':
                return react_1["default"].createElement(PlayerStats_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'usersList':
                return react_1["default"].createElement(UsersList_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'organizationProfilesList':
                return (react_1["default"].createElement(OrganizationProfilesList_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'privateContentBoundary':
                return (react_1["default"].createElement(PrivateContentBoundary_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'banners':
                return react_1["default"].createElement(Banners_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'products':
                return react_1["default"].createElement(Products_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'textBlock':
                return react_1["default"].createElement(TextBlock_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'profile':
                return (react_1["default"].createElement(Profile_1["default"], { data: widget, renderEmpty: renderEmpty, renderLink: renderLink }));
            case 'advert':
                return react_1["default"].createElement(Advert_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'squad':
                return react_1["default"].createElement(Squad_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'hiddenContent':
                return react_1["default"].createElement(HiddenContent_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'hiddenContentEnd':
                return react_1["default"].createElement(HiddenContentEnd_1["default"], null);
            case 'footnotes':
                return react_1["default"].createElement(Footnotes_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'ctk-widget':
                return (react_1["default"].createElement(CtkWidget_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'tableOfContents':
                return react_1["default"].createElement(TableOfContents_1["default"], { data: widget });
            case 'ecomail':
                return react_1["default"].createElement(EcoMail_1["default"], { data: widget, renderEmpty: renderEmpty });
            case 'enetpulseWidget':
                return (react_1["default"].createElement(EnetpulseWidget_1["default"], { data: widget, renderEmpty: renderEmpty }));
            case 'htmlList':
                return react_1["default"].createElement(HtmlList_1["default"], { data: widget, renderEmpty: renderEmpty });
            default:
                return null;
        }
    }
    var content = render();
    if (!content) {
        return null;
    }
    if (['textBlock', 'text'].includes(widget.type)) {
        return content;
    }
    if (widget.type === 'advert' && !renderEmpty) {
        return content;
    }
    return (react_1["default"].createElement(exports.WidgetWrapper, { className: "content-widget", maxWidth: getMaxWidth(widget, theme), hasAppPadding: getHasAppPadding(widget), hasBottomGutter: getHasBottomGutter(widget) }, content));
};
exports["default"] = styled_components_1.withTheme(GenericWidget);
var templateObject_1;
